module.exports = "<div ui-view=content></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/app.item/appItems.html
// module id = 1038
// module chunks = 0